import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, TS_Slider } from '@nu-art/thunderstorm-frontend/index';
class PgDev_TS_Slider_Class extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return;
    }
    render() {
        return _jsx(TS_Slider, { min: 0, max: 10 });
    }
}
export const PgDev_TS_Slider = { name: 'Slider Test', key: 'slider-test', renderer: PgDev_TS_Slider_Class };
